import { Button, Collapse, Divider, Modal, Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	WarningMessageBox
} from "../../components/styled/common";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useBannerContext } from "../../context/BannerContext/BannerContext";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getBannerItems } from "./constants";

const EditBanner = () => {
	const { id } = useParams<{ id: string }>();
	const { updateBanner, operationStatus, getBannerDetails, bannerDetail, setBannerForm } = useBannerContext();
	const [hasNavigation, setHasNavigation] = useState<boolean | undefined>(bannerDetail?.hasNavigation);
	const [isNavigationModalVisible, setIsNavigationModalVisible] = useState(false);

	useEffect(() => {
		if (id) {
			getBannerDetails(id);
		}
	}, [id]);

	useEffect(() => {
		setHasNavigation(bannerDetail?.hasNavigation);
	}, [bannerDetail]);


	const handleHasNavigationChange = (checked: boolean) => {
		const isNavigationBeingDisabled = hasNavigation === true && checked === false;

		if (isNavigationBeingDisabled) {
			setIsNavigationModalVisible(true);
			return;
		}

		setHasNavigation(checked);
		setBannerForm(prevState => ({ ...prevState, hasNavigation: checked }));
	};

	const bannerItems = getBannerItems({
		hasNavigation,
		onHasNavigationChange: handleHasNavigationChange,
	});

	const handleDisableNavigationConfirm = () => {
		setHasNavigation(false);
		setBannerForm(prevState => ({
			...prevState,
			hasNavigation: false,
			bannerLocalizable: prevState.bannerLocalizable.map(localizable => ({
				...localizable,
				url: "",
			})),
		}));
		setIsNavigationModalVisible(false);
	};

	return (
		<ActionContainer>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<ActionItemsContainer>
					<>
						<h3>Banner Güncelle</h3>
						<Divider />
						<Collapse
							items={bannerItems}
							expandIconPosition="end"
							bordered={false}
							ghost
							expandIcon={CollapseExpandIcon}
							defaultActiveKey={["1", "2", "3", "4"]}
						/>
					</>
					<SubmitButtonOverlay>
						<MainButtonComponent onClick={updateBanner} type="default" loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
							Güncelle
						</MainButtonComponent>
					</SubmitButtonOverlay>
					<Modal
						title="Yönlendirme kapatılsın mı?"
						open={isNavigationModalVisible}
						onCancel={() => setIsNavigationModalVisible(false)}
						centered
						footer={[
							<Button key="cancel" type="text" onClick={() => setIsNavigationModalVisible(false)}>
								Vazgeç
							</Button>,
							<Button key="confirm" type="primary" danger onClick={handleDisableNavigationConfirm}>
								Evet
							</Button>,
						]}
					>
						<p>Bu banner için yönlendirmeyi kapatmak istediğinizden emin misiniz?</p>
						<WarningMessageBox>Yönlendirme kapatılırsa, form gönderimi sonrası, tüm URL alanları temizlenecektir. Bu işlem geri alınamaz.</WarningMessageBox>
					</Modal>
				</ActionItemsContainer>
			</Spin>
		</ActionContainer>
	);
};

export default EditBanner;
